import './expo_page.css';
import React from 'react';


function Attribution() {
return (
    <div>
        <div className="home-title">
        <h1>Attribuzioni & Licenze</h1>
        </div>
        <br />
        <div className="geo-container">
        <div className="tools">
        <section className="py-12 text-left">
        <div className="container mx-auto">
        <p>
        <strong>Ultimo aggiornamento:</strong> 19/08/2025
        </p>


        <p>
        In questa pagina sono raccolte le attribuzioni e le licenze relative ai dati geografici utilizzati all’interno della mappa.
        </p>


        <h2 className="text-im mt-6">Regione Emilia-Romagna</h2>
        <p className="text-gray-600 mt-2">
        I dati geografici sono forniti dal <strong>Geoportale della Regione Emilia-Romagna</strong>.
        </p>
        <ul className="text-gray-600 mt-2 list-disc list-inside">
        <li>
        Licenza: <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons Attribuzione 4.0 (CC BY 4.0)</a>
        </li>
        <li>
        Fonte: <a href="https://geoportale.regione.emilia-romagna.it/catalogo/dati-cartografici/informazioni-geoscientifiche/geologia/banca-dati-geognostica/layer-1" target="_blank" rel="noopener noreferrer">Geoportale Regione Emilia-Romagna</a>
        </li>
        <li>
        Modifiche: i dati possono essere stati rielaborati o integrati per l’uso all’interno di questa applicazione.
        </li>
        </ul>

        <h2 className="text-im mt-6">Regione Lombardia</h2>
        <p className="text-gray-600 mt-2">
        I dati geografici sono forniti dal <strong>Geoportale della Lombardia</strong>.
        </p>
        <ul className="text-gray-600 mt-2 list-disc list-inside">
        <li>
        Licenza: <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons Attribuzione 4.0 (CC BY 4.0)</a>
        </li>
        <li>
        Fonte: <a href="https://www.geoportale.regione.lombardia.it/en/metadati?p_p_id=detailSheetMetadata_WAR_gptmetadataportlet&p_p_lifecycle=0&p_p_state=normal&p_p_mode=view&_detailSheetMetadata_WAR_gptmetadataportlet_identifier=r_lombar%3Ae6bcffe3-73de-4681-8e7e-3be5cb50c70a&_jsfBridgeRedirect=true" target="_blank" rel="noopener noreferrer">Geoportale Regione Lombardia</a>
        </li>
        <li>
        Modifiche: i dati possono essere stati rielaborati o integrati per l’uso all’interno di questa applicazione.
        </li>
        </ul>


        <p className="text-gray-600 mt-6">
        Ulteriori regioni e fonti verranno elencate qui man mano che i dati saranno integrati.
        </p>
        </div>
        </section>
        </div>
        </div>
        </div>
        );
    }


export default Attribution;




